import standardAPI from '@/api/standard_items';

const state = {
  pc_categories: [],
  pc_categories_status: '',
  pc_categories_MetaData: {},
  pc_categories_page: 1,
  pc_categories_perPage: 10,
};

const responseUrl = '/pc-categories';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_pc_categories ({ commit }, getOptions) {
    commit('PC_CATEGORIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PC_CATEGORIES_SUCCESS', response);
            commit('PC_CATEGORIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PC_CATEGORIES_READY');
            reject(response);
          } else {
            commit('PC_CATEGORIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },

  add_pc_category ({ commit, dispatch }, itemData) {
    commit('PC_CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PC_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },

  edit_pc_category ({ commit, dispatch }, itemData) {
    commit('PC_CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('PC_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },

  remove_pc_category ({ commit, dispatch }, itemData) {
    commit('PC_CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('PC_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },

  reorder_pc_category ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },

  set_pc_category_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },

  universal_response ({ commit }, itemData) {
    const preparedData = {
      itemData,
      method: itemData.method || 'put',
      url: itemData.url,
    };
    return new Promise((resolve, reject) => {
      standardAPI.universal_response(preparedData,
        (response) => {
          if (response.status && response.status !== 403) {
            if (response.status === 'reorder' || response.status === 'success') { resolve(response); }
          } else if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.pc_categories_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.pc_categories_perPage = max;
  },
  PC_CATEGORIES_READY: (state) => {
    state.pc_categories_status = 'ready';
  },
  PC_CATEGORIES_REQUEST: (state) => {
    state.pc_categories_status = 'loading';
  },
  PC_CATEGORIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.pc_categories_MetaData.meta = response.meta;
      state.pc_categories_MetaData.links = response.links;
    }
    state.pc_categories = response.data;
    state.pc_categories_status = 'success';
  },
  PC_CATEGORIES_ERROR: (state) => {
    state.pc_categories_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
